const TARGET_SALESPERSON_LIST = "/v1/target/salesperson/list";
const TARGET_SALESPERSON_GET_SINGLE = "/v1/target/salesperson/single";
const TARGET_SALESPERSON_ADD = "/v1/target/salesperson/add";
const TARGET_SALESPERSON_UPDATE = "/v1/target/salesperson/update";
const TARGET_SALESPERSON_DELETE = "/v1/target/salesperson/delete";
const TARGET_CURRENT_LIST = "/v1/target/current/list";
const TARGET_CURRENT_GET_SINGLE = "/v1/target/current/single";
const TARGET_CURRENT_ADD = "/v1/target/current/add";
const TARGET_CURRENT_UPDATE = "/v1/target/current/update";
const TARGET_CURRENT_DELETE = "/v1/target/current/delete";

const TARGET_API_URL_LIST = {
    TARGET_SALESPERSON_LIST,
    TARGET_SALESPERSON_GET_SINGLE,
    TARGET_SALESPERSON_ADD,
    TARGET_SALESPERSON_UPDATE,
    TARGET_SALESPERSON_DELETE,
    TARGET_CURRENT_LIST,
    TARGET_CURRENT_GET_SINGLE,
    TARGET_CURRENT_ADD,
    TARGET_CURRENT_UPDATE,
    TARGET_CURRENT_DELETE,
}

export { TARGET_API_URL_LIST };